import { inject, Pipe, PipeTransform } from '@angular/core';
import { UnitSystemType } from '@data-access';
import { UnitCategory } from '../utils/unit-conversion.utils';
import { UnitSystemService } from '../services/unit-system.service';

/**
 * Returns unformatted number. Use with number formatting pipe
 */

@Pipe({ name: 'unitValue', standalone: true })
export class UnitValuePipe implements PipeTransform {
  private service = inject(UnitSystemService);

  transform(
    unitsMap: Record<string, number> | null | undefined,
    category: UnitCategory,
    unitSystem?: UnitSystemType | null,
  ): number | null {
    return this.service.resolveValue(unitsMap, category, unitSystem);
  }
}
